import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Bredcom from '../components/Bredcom/Bredcom';
import Footer from '../components/Footer/Footer';
import Upis from '../components/Upis/Upis';

function UpisPage() {
    return (
        <>
            <Navbar />
            <Bredcom title="Početna" subtitle="Upis" />
            <Upis />
            <Footer />
        </>
    );
}

export default UpisPage;
